<template>
  <div class="unit-editor">
    <header class="topbar">
      <img
        src="@/assets/logogruas.png"
        alt="HomePage"
        class="logo-button"
        @click="backMainPanel"
      />
      <div class="topbar-title">
        <div class="kicker">Mantenimiento</div>
        <h1>Editar unidad</h1>
        <p class="subtitle">
          {{ localUnitDetails.unit_short_id || "—" }} ·
          {{ localUnitDetails.unit_plates || "Sin placas" }}
        </p>
      </div>

      <div class="topbar-actions">
        <button class="btn ghost" @click="resetLocal" :disabled="saving_unit || !isDirty">
          Descartar cambios
        </button>
        <button
          v-if="canUpdate"
          class="btn primary"
          @click="saveUnitProfile"
          :disabled="saving_unit || !isDirty"
        >
          <span v-if="!saving_unit">Guardar</span>
          <span v-else>Guardando…</span>
        </button>
      </div>
    </header>

    <div class="tabs-wrap">
      <nav class="tabs">
        <button
          v-for="t in visibleTabs"
          :key="t.key"
          class="tab"
          :class="{ active: activeTab === t.key }"
          @click="activeTab = t.key"
        >
          <span class="tab-label">{{ t.label }}</span>
          <span class="tab-hint" v-if="t.hint">{{ t.hint }}</span>
        </button>
      </nav>

      <div class="tab-panel">
        <section v-if="activeTab === 'general'">
          <div class="main-data-container">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Datos de la unidad</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">ID</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.unit_id" type="text" placeholder="Introduce el ID de la unidad" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label"># Económico</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.unit_short_id" type="text" placeholder="Introduce el número económico" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Tipo unidad</label>
                      <div class="field-control">
                        <select v-model="localUnitDetails.unit_type">
                          <option :value="1">CAJA SECA</option>
                          <option :value="2">INDUSTRIALES</option>
                          <option :value="3">MONTACARGAS</option>
                          <option :value="4">NODRIZAS</option>
                          <option :value="5">PARTICULARES</option>
                          <option :value="6">PLATAFORMAS Y LOW BOYS</option>
                          <option :value="7">RAMPAS</option>
                          <option :value="8">RAMPAS 4 CARROS</option>
                          <option :value="9">RAMPAS GRANDES</option>
                          <option :value="10">REMOLQUES CHICOS</option>
                          <option :value="11">REMOLQUES GRANDES</option>
                          <option :value="12">REPARTO</option>
                          <option :value="13">TITANES</option>
                          <option :value="14">TRACTORES</option>
                          <option :value="15">Rescate</option>
                          <option :value="16">AUXILIO VIAL</option>
                        </select>
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Categoría</label>
                      <div class="field-control">
                        <select v-model="localUnitDetails.unit_category">
                          <option :value="1">Categoría A</option>
                          <option :value="2">Categoría B</option>
                          <option :value="3">Categoría C</option>
                          <option :value="4">Categoría D</option>
                          <option :value="5">AUXILIO VIAL</option>
                          <option :value="6">MONTACARGAS</option>
                          <option :value="7">NO APLICA</option>
                        </select>
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Marca</label>
                      <div class="field-control">
                        <select v-model="localUnitDetails.unit_brand">
                          <option :value="1">Hino</option>
                          <option :value="2">Volkswagen</option>
                          <option :value="3">Dodge</option>
                          <option :value="4">Freightliner</option>
                          <option :value="5">Mercedez Benz</option>
                          <option :value="6">KENWORTH</option>
                          <option :value="7">Nissan</option>
                          <option :value="8">Vento</option>
                          <option :value="9">Honda</option>
                          <option :value="10">Toyota</option>
                          <option :value="11">Zoomlion</option>
                          <option :value="12">Hyster</option>
                          <option :value="13">Taylor</option>
                          <option :value="14">Heli</option>
                          <option :value="15">CHL</option>
                          <option :value="16">AYUDANTE</option>
                          <option :value="18">SANY</option>
                          <option :value="19">Bombardier</option>
                          <option :value="20">Buick</option>
                          <option :value="21">BYD</option>
                          <option :value="22">Chevrolet</option>
                          <option :value="23">Clark</option>
                          <option :value="24">Cupra</option>
                          <option :value="25">Eager Beaver</option>
                          <option :value="26">Fegar</option>
                          <option :value="27">Grove</option>
                          <option :value="28">HINO</option>
                          <option :value="29">Kaufman</option>
                          <option :value="30">KIA</option>
                          <option :value="31">Mitsubishi</option>
                          <option :value="32">Natsa</option>
                          <option :value="33">Polaris</option>
                          <option :value="34">P&H</option>
                          <option :value="35">Ramirez</option>
                          <option :value="36">Sterling</option>
                          <option :value="37">Trail King</option>
                          <option :value="38">Versa-Lift</option>
                          <option :value="39">WABA</option>
                          <option :value="40">NO APLICA</option>
                        </select>
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Sub marca</label>
                      <div class="field-control">
                        <select v-model="localUnitDetails.unit_sub_brand">
                          <option value="716 SUPERLONG">716 SUPERLONG</option>
                          <option value="FL-M2-106-25K-15">FL-M2-106-25K-15</option>
                          <option value="M2106 35K EUROV">M2106 35K EUROV</option>
                          <option value="FL-M2-106-16">FL-M2-106-16</option>
                          <option value="CL120">CL120</option>
                          <option value="M2 35K">M2 35K</option>
                          <option value="FL-M2-35K-12">FL-M2-35K-12</option>
                          <option value="816 SUPERLONG">816 SUPERLONG</option>
                          <option value="CASCADIA DD15">CASCADIA DD15</option>
                          <option value="716 SUPER LONG">716 SUPER LONG</option>
                          <option value="RAM 4000">RAM 4000</option>
                          <option value="TIPO T800B">TIPO T800B</option>
                          <option value="M2 106 25K">M2 106 25K</option>
                          <option value="FL360 2528">FL360 2528</option>
                          <option value="Modelo 9.170 4X2">Modelo 9.170 4X2</option>
                          <option value="Modelo 9.170 DELIVERY">Modelo 9.170 DELIVERY</option>
                          <option value="CL120 COLUMBIA">CL120 COLUMBIA</option>
                          <option value="TIPO T800B">TIPO T800B</option>
                          <option value="RAM 4000 GASOLINA">RAM 4000 GASOLINA</option>
                          <option value="M2 33K">M2 33K</option>
                          <option value="M2 25K">M2 25K</option>
                          <option value="Modelo 9.170 DELIVERY 4x2">Modelo 9.170 DELIVERY 4x2</option>
                          <option value="RAM 4000  DIESEL">RAM 4000  DIESEL</option>
                          <option value="FL360">FL360</option>
                          <option value="KENMEX 5a. RUEDA">KENMEX 5a. RUEDA</option>
                          <option value="March">March</option>
                          <option value="Moto">Moto</option>
                          <option value="GL150 CARGO">GL150 CARGO</option>
                          <option value="8FDU30"> 8FDU30</option>
                          <option value="7FDU70"> 7FDU70</option>
                          <option value="02-7FD40"> 02-7FD40</option>
                          <option value="FD35Z"> FD35Z</option>
                          <option value="FD50"> FD50</option>
                          <option value="FD70"> FD70</option>
                          <option value="H280XL"> H280XL</option>
                          <option value="FD35"> FD35</option>
                          <option value="FD50"> FD50</option>
                          <option value="FD70"> FD70</option>
                          <option value="T360L"> T360L</option>
                          <option value="T360L"> T360L 36,000 LBS</option>
                          <option value="FD160"> FD160</option>
                          <option value="CPCD70-W2G"> CPCD70-W2G</option>
                          <option value="CPQYD50-KUG3"> CPQYD50-KUG3</option>
                          <option value="CPCD100-W5G"> CPCD100-W5G</option>
                          <option value="CPCD35-W4H"> CPCD35-W4H</option>
                          <option value="CPQYD50-KU2K2C">CPQYD50-KU2K2C</option>
                          <option value="CPCD70-W2K2"> CPCD70-W2K2</option>
                          <option value="CPCD40-M4K2"> CPCD40-M4K2</option>
                          <option value="CPQYD40-KU2K2"> CPQYD40-KU2K2</option>
                          <option value="HQC42503SWS12E - 2024"> HQC42503SWS12E - 2024</option>
                          <option value="HQC343DE2 - 2024">HQC343DE2 - 2024</option>
                          <option value="11.180 DELIVERY 4X2">11.180 DELIVERY 4X2</option>
                          <option value="17.230 4X2 ROBUST (CONSTELATION)">17.230 4X2 ROBUST (CONSTELATION)</option>
                          <option value="25/35E 35,000 LBS">25/35E 35,000 LBS</option>
                          <option value="7FGAU50">7FGAU50</option>
                          <option value="818 SUPER LONG EURO 6">818 SUPER LONG EURO 6</option>
                          <option value="9.180 DELIVERY E6 4X2">9.180 DELIVERY E6 4X2</option>
                          <option value="AT4425G">AT4425G</option>
                          <option value="BLAZER C RS">BLAZER C RS</option>
                          <option value="CRF125FB">CRF125FB</option>
                          <option value="CB160F">CB160F</option>
                          <option value="CMP25">CMP25</option>
                          <option value="CMP40D">CMP40D</option>
                          <option value="CMP75SE">CMP75SE</option>
                          <option value="CRV TOURING CVT">CRV TOURING CVT</option>
                          <option value="DUTRO 300">DUTRO 300</option>
                          <option value="ENCORE GX SPORT TOURING">ENCORE GX SPORT TOURING</option>
                          <option value="FRONTIER V6 CREW CAB PRO-4X 4X2 T/A">FRONTIER V6 CREW CAB PRO-4X 4X2 T/A</option>
                          <option value="GLB 220 4MATIC MH">GLB 220 4MATIC MH</option>
                          <option value="HIGHLANDER">HIGHLANDER</option>
                          <option value="HILUX CABINA SENCILLA">HILUX CABINA SENCILLA</option>
                          <option value="HRV PRIME">HRV PRIME</option>
                          <option value="HRV SPORT">HRV SPORT</option>
                          <option value="KODIAK SERIE 6">KODIAK SERIE 6</option>
                          <option value="L200 GLS PICK UP DOB CAB 4X4 AT DIESEL">L200 GLS PICK UP DOB CAB 4X4 AT DIESEL</option>
                          <option value="L200 GLX PICK UP DOB CAB 4X2 MAN">L200 GLX PICK UP DOB CAB 4X2 MAN</option>
                          <option value="L200 GLX PICK UP DOBLE CABINA 4X4">L200 GLX PICK UP DOBLE CABINA 4X4</option>
                          <option value="LEON">LEON</option>
                          <option value="M 7500 AC TERRA">M 7500 AC TERRA</option>
                          <option value="M2 106 35K">M2 106 35K</option>
                          <option value="M2 106 60K">M2 106 60K</option>
                          <option value="M2 60K">M2 60K</option>
                          <option value="MARCH ACTIVE TM AA">MARCH ACTIVE TM AA</option>
                          <option value="MARCH ACTIVE TM AA STD">MARCH ACTIVE TM AA STD</option>
                          <option value="MARCH SENSE T/M">MARCH SENSE T/M</option>
                          <option value="MARCH SENSE TM">MARCH SENSE TM</option>
                          <option value="NP300 DOBLE CABINA S TM AC">NP300 DOBLE CABINA S TM AC</option>
                          <option value="NP300 DOBLE CABINA SE AC">NP300 DOBLE CABINA SE AC</option>
                          <option value="NP300 PICK UP T/M">NP300 PICK UP T/M</option>
                          <option value="OUTLANDER MAX DPS 570">OUTLANDER MAX DPS 570</option>
                          <option value="PRIUS C">PRIUS C</option>
                          <option value="PRIUS C HATCHBACK">PRIUS C HATCHBACK</option>
                          <option value="PRIUS HYBRID">PRIUS HYBRID</option>
                          <option value="RAIZE XLE BITONO">RAIZE XLE BITONO</option>
                          <option value="RAM 700 REGULAR CAB">RAM 700 REGULAR CAB</option>
                          <option value="RGR RANGER CREW SP 570 PREMIUM">RGR RANGER CREW SP 570 PREMIUM</option>
                          <option value="SCP25C6">SCP25C6</option>
                          <option value="SIENNA HV XSE">SIENNA HV XSE</option>
                          <option value="SILVERADO DOBLE CABINA 4X2 PAQ. E WT">SILVERADO DOBLE CABINA 4X2 PAQ. E WT</option>
                          <option value="SONG PRO">SONG PRO</option>
                          <option value="SPA20AC">SPA20AC</option>
                          <option value="SPORTAGE PE2.0L LX AT">SPORTAGE PE2.0L LX AT</option>
                          <option value="STC300T5 (30 ton)">STC300T5 (30 ton)</option>
                          <option value="STC750 (75 ton)">STC750 (75 ton)</option>
                          <option value="SUBURBAN SUV">SUBURBAN SUV</option>
                          <option value="T300">T300</option>
                          <option value="T300A">T300A</option>
                          <option value="TIIDA SEDAN DRIVE T/M C/A">TIIDA SEDAN DRIVE T/M C/A</option>
                          <option value="TIIDA SEDAN SENSE T/M A/A">TIIDA SEDAN SENSE T/M A/A</option>
                          <option value="TORNADO VAN CARGO B LS">TORNADO VAN CARGO B LS</option>
                          <option value="V-DRIVE 4 PUERTAS T/M">V-DRIVE 4 PUERTAS T/M</option>
                          <option value="VENTO TIP STARLINE TIPTRONIC AUTOMÁTICO">VENTO TIP STARLINE TIPTRONIC AUTOMÁTICO</option>
                          <option value="VERSA ADVANCE CVT">VERSA ADVANCE CVT</option>
                          <option value="VERSA SENSE CVT">VERSA SENSE CVT</option>
                          <option value="VERSA SENSE TM AC">VERSA SENSE TM AC</option>
                          <option value="YARIS 5DR AT PREMIUM">YARIS 5DR AT PREMIUM</option>
                          <option value="YARIS 5DR MT CORE">YARIS 5DR MT CORE</option>
                          <option value="YARIS HB S CVT">YARIS HB S CVT</option>
                          <option value="NO APLICA">NO APLICA</option>
                        </select>
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Serie</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.unit_engine_num" type="text" placeholder="Introduce la serie" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Año modelo</label>
                      <div class="field-control">
                        <input v-model.number="localUnitDetails.unit_model" type="number" inputmode="numeric" placeholder="Ej. 2024" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Placas</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.unit_plates" type="text" placeholder="Introduce las placas" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Clase</label>
                      <div class="field-control">
                        <select v-model="localUnitDetails.unit_class">
                          <option :value="1">Federales</option>
                          <option :value="2">Particulares</option>
                          <option :value="3">Reparto</option>
                          <option :value="4">N/A</option>
                          <option :value="5">Sitio</option>
                          <option :value="6">Discapacitado</option>
                          <option :value="7">Auxilio</option>
                        </select>
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">GPS</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.gps_id" type="text" placeholder="Identificador GPS" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Propietario</label>
                      <div class="field-control">
                        <select v-model="localUnitDetails.unit_owner">
                          <option :value="1">Gruas Monterrey</option>
                          <option :value="2">Gruas Saltillo</option>
                          <option :value="3">Metrogruas</option>
                          <option :value="4">Gruas Alfa</option>
                          <option :value="5">Enzzo Industrias</option>
                          <option :value="6">Particular</option>
                        </select>
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Empresa asignada</label>
                      <div class="field-control">
                        <select v-model="localUnitDetails.assigned_owner">
                          <option :value="null">—</option>
                          <option :value="1">Gruas Monterrey</option>
                          <option :value="2">Gruas Saltillo</option>
                          <option :value="3">Metrogruas</option>
                          <option :value="4">Gruas Alfa</option>
                          <option :value="5">Enzzo Industrias</option>
                          <option :value="6">Particular</option>
                        </select>
                      </div>
                    </div>

                    <div class="field span-2">
                      <label class="field-label">Comentarios</label>
                      <div class="field-control">
                        <textarea v-model="localUnitDetails.comments" placeholder="Ingrese información adicional"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Administrativo</h4>
                  <div class="pill">Finanzas</div>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">Fecha de compra</label>
                      <div class="field-control">
                        <input v-model="localUnitDetails.buy_time" type="date" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Valor unidad completa</label>
                      <div class="field-control">
                        <input v-model.number="localUnitDetails.current_total_value" type="number" step="0.01" inputmode="decimal" placeholder="Ej. 250000.00" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Propietario de factura</label>
                      <div class="field-control">
                        <select v-model="localUnitDetails.invoice_owner">
                          <option :value="null">—</option>
                          <option :value="1">Gruas Monterrey</option>
                          <option :value="2">Gruas Saltillo</option>
                          <option :value="3">Metrogruas</option>
                          <option :value="4">Gruas Alfa</option>
                          <option :value="5">Enzzo Industrias</option>
                          <option :value="6">Particular</option>
                        </select>
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Fecha actualización de valor</label>
                      <div class="field-control">
                        <input v-model="localUnitDetails.value_update_time" type="date" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        <section v-else-if="activeTab === 'truck'">
          <div class="main-data-container">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Información de camión</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">Factura camión</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.invoice_number" type="text" placeholder="Número de factura" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Tipo de motor</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.engine_type" type="text" placeholder="Ej. Diésel" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Pedimento camión</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.truck_motion" type="text" placeholder="Pedimento" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Proveedor</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.vendor" type="text" placeholder="Proveedor" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Valor del camión</label>
                      <div class="field-control">
                        <input v-model.number="localUnitDetails.truck_value" type="number" step="0.01" inputmode="decimal" placeholder="Ej. 180000.00" />
                      </div>
                    </div>

                    <div class="field span-2">
                      <label class="field-label">Comentarios</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.comments" type="text" placeholder="Compra, ajuste, baja, etc." />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="maintenance-side">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Información de equipo</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid form-grid-single">
                    <div class="field">
                      <label class="field-label">Factura equipo</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.equipment_invoice_number" type="text" placeholder="Número de factura" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Año modelo equipo</label>
                      <div class="field-control">
                        <input v-model.number="localUnitDetails.equipment_model_year" type="number" inputmode="numeric" placeholder="Ej. 2024" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Marca equipo</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.equipment_brand" type="text" placeholder="Ej. Hyster" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Modelo equipo</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.equipment_model" type="text" placeholder="Ej. 8FDU30" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Número de serie equipo</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.equipment_serial_number" type="text" placeholder="Serie" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Proveedor equipo</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.equipment_vendor" type="text" placeholder="Proveedor" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Pedimento equipo</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.equipment_motion" type="text" placeholder="Pedimento" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Fecha de compra equipo</label>
                      <div class="field-control">
                        <input v-model="localUnitDetails.equipment_buy_time" type="date" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Valor del equipo</label>
                      <div class="field-control">
                        <input v-model.number="localUnitDetails.equipment_value" type="number" step="0.01" inputmode="decimal" placeholder="Ej. 90000.00" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Comentarios</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.equipment_comments" type="text" placeholder="Compra, ajuste, baja, etc." />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'informative'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>SCT. Carta Porte</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">Peso bruto (kg)</label>
                      <div class="field-control">
                        <input v-model.number="localUnitDetails.gross_weight" type="number" step="0.01" inputmode="decimal" placeholder="Ej. 12500.00" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Configuración vehicular</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.vehicular_configuration" type="text" placeholder="Ej. C2, T3-S2..." />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Subtipo de remolque</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.trailer_sub_type" type="text" placeholder="Ej. Lowboy, plataforma..." />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Permiso SCT</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.sct_permission" type="text" placeholder="Ej. SCT-XXXX" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Pólizas</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">Aseguradora póliza flotilla</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.fleet_policy_insurance" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Número póliza flotilla</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.fleet_policy_number" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Cobertura póliza flotilla</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.fleet_policy_coverage" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Vigencia póliza flotilla</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.fleet_policy_validity" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Costo anual póliza flotilla</label>
                      <div class="field-control">
                        <input v-model.number="localUnitDetails.fleet_policy_annual_cost" type="number" step="0.01" inputmode="decimal" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Aseguradora póliza RC</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.civil_liability_insurance" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Número póliza RC</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.civil_liability_policy" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Vigencia póliza RC</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.rc_policy_validity" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Costo anual póliza RC</label>
                      <div class="field-control">
                        <input v-model.number="localUnitDetails.rc_policy_annual_cost" type="number" step="0.01" inputmode="decimal" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Verificaciones</h4>
                  <button type="button" class="btn ghost mini-action-btn" @click="addVerification">Agregar</button>
                </div>
                <div class="container-card-body">
                  <div v-for="(verification, index) in verificationsList" :key="`verification-${index}`" class="list-row">
                    <div class="field">
                      <label class="field-label">Tipo</label>
                      <div class="field-control">
                        <input v-model.trim="verification.type" type="text" placeholder="Ej. HUMOS, NO APLICA" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Folio</label>
                      <div class="field-control">
                        <input v-model.trim="verification.folio" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Fecha verificación</label>
                      <div class="field-control">
                        <input v-model="verification.verification_date" type="date" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Periodo</label>
                      <div class="field-control">
                        <input v-model.trim="verification.period" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Vencimiento</label>
                      <div class="field-control">
                        <input v-model="verification.expiration" type="date" />
                      </div>
                    </div>
                    <button type="button" class="btn remove-item-btn" @click="removeVerification(index)">Quitar</button>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Arrendamientos</h4>
                  <button type="button" class="btn ghost mini-action-btn" @click="addLease">Agregar</button>
                </div>
                <div class="container-card-body">
                  <div v-for="(lease, index) in leasesList" :key="`lease-${index}`" class="list-row">
                    <div class="field">
                      <label class="field-label">Arrendadora</label>
                      <div class="field-control">
                        <input v-model.trim="lease.lessor" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">No. contrato</label>
                      <div class="field-control">
                        <input v-model.trim="lease.contract_number" type="text" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Inicio</label>
                      <div class="field-control">
                        <input v-model="lease.start_date" type="date" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Término</label>
                      <div class="field-control">
                        <input v-model="lease.end_date" type="date" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Monto mensualidad</label>
                      <div class="field-control">
                        <input v-model.number="lease.monthly_amount" type="number" step="0.01" inputmode="decimal" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Monto opción a compra</label>
                      <div class="field-control">
                        <input v-model.number="lease.purchase_option_amount" type="number" step="0.01" inputmode="decimal" />
                      </div>
                    </div>
                    <button type="button" class="btn remove-item-btn" @click="removeLease(index)">Quitar</button>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Certificaciones</h4>
                </div>
                <div class="container-card-body">
                  <div class="field">
                    <label class="field-label">¿Esta unidad requiere certificaciones?</label>
                    <div class="field-control">
                      <div class="toggle">
                        <input
                          id="enable-certifications"
                          type="checkbox"
                          v-model="localUnitDetails.enable_certifications"
                          @change="onEnableCertificationsChange"
                        />
                        <label for="enable-certifications">Habilitar certificaciones</label>
                      </div>
                    </div>
                    <p class="field-hint">
                      Al activarla aparece la sección para registrar certificaciones, su vigencia y sus documentos.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'certifications'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Certificaciones</h4>
                  <button type="button" class="btn ghost mini-action-btn" @click="addCertification">Agregar</button>
                </div>
                <div class="container-card-body">
                  <p class="field-hint">Cada certificación guarda el nombre, la fecha en que se obtuvo, su vencimiento, comentarios y documentos.</p>
                  <div v-for="(cert, index) in certificationsList" :key="cert.id" class="cert-block">
                    <div class="cert-block-head">
                      <h5>{{ cert.name || "Nueva certificación" }}</h5>
                      <span v-if="certificationStatus(cert) === 'Vencida'" class="pill danger">Vencida</span>
                      <span v-else-if="certificationStatus(cert) === 'Vigente'" class="pill ok">Vigente</span>
                      <button type="button" class="btn remove-item-btn" @click="removeCertification(index)">Quitar</button>
                    </div>
                    <div class="form-grid">
                      <div class="field">
                        <label class="field-label">Nombre</label>
                        <div class="field-control">
                          <input v-model.trim="cert.name" type="text" placeholder="Ej. Certificación cliente X" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Fecha de obtención</label>
                        <div class="field-control">
                          <input v-model="cert.obtained_date" type="date" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Vencimiento</label>
                        <div class="field-control">
                          <input v-model="cert.expiration" type="date" />
                        </div>
                      </div>
                      <div class="field span-2">
                        <label class="field-label">Comentarios</label>
                        <div class="field-control">
                          <textarea v-model.trim="cert.comments" placeholder="Notas sobre esta certificación"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="media-section cert-files">
                      <div class="media-header">
                        <h5>Documentos</h5>
                      </div>
                      <p v-if="!savedCertificationIds.has(cert.id)" class="field-hint">
                        Guarda la unidad para adjuntar documentos a esta certificación.
                      </p>
                      <div v-else class="media-grid">
                        <button
                          type="button"
                          class="media-card media-add"
                          @click="uploadUnitFile('certification', cert.id)"
                          :disabled="uploadingMedia"
                        >
                          <span class="media-plus">+</span>
                          <span class="media-add-label">Agregar documento</span>
                        </button>
                        <div class="media-card" v-for="item in filesForCertification(cert.id)" :key="item.file_id">
                          <img
                            v-if="item.mime_type && item.mime_type.startsWith('image/')"
                            :src="item.preview_url"
                            :alt="item.title || item.file_name"
                            class="media-preview"
                          />
                          <div v-else class="media-doc-icon">DOC</div>
                          <div class="media-meta">
                            <h6>{{ item.title || item.file_name || "Documento" }}</h6>
                            <p>{{ item.description || "Sin descripción" }}</p>
                          </div>
                          <div class="media-actions">
                            <button type="button" class="btn ghost media-btn" @click="openFile(item)">Abrir</button>
                            <button type="button" class="btn ghost media-btn" @click="downloadFile(item)">Descargar</button>
                            <button type="button" class="btn remove-item-btn media-btn" @click="deleteUnitFile(item.file_id)">Eliminar</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'bajas'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Información de baja</h4>
                  <div class="pill danger">Baja</div>
                </div>
                <div class="container-card-body">
                  <div class="form-grid form-grid-single">
                    <div class="field">
                      <label class="field-label">¿Está dada de baja?</label>
                      <div class="field-control">
                        <div class="toggle">
                          <input id="deco" type="checkbox" v-model="localUnitDetails.is_decomissioned" />
                          <label for="deco">BAJA</label>
                        </div>
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Fecha de baja</label>
                      <div class="field-control">
                        <input v-model="localUnitDetails.decomission_time" type="datetime-local" :disabled="!localUnitDetails.is_decomissioned" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Razón</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.decomission_reason" type="text" placeholder="Motivo" :disabled="!localUnitDetails.is_decomissioned" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Comprador</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.buyer" type="text" placeholder="Nombre del comprador" :disabled="!localUnitDetails.is_decomissioned" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Vendedor</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.decomission_seller" type="text" :disabled="!localUnitDetails.is_decomissioned" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Número de factura</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.decomission_invoice_number" type="text" :disabled="!localUnitDetails.is_decomissioned" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Valor factura</label>
                      <div class="field-control">
                        <input v-model.number="localUnitDetails.decomission_invoice_value" type="number" step="0.01" inputmode="decimal" :disabled="!localUnitDetails.is_decomissioned" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Valor real de venta</label>
                      <div class="field-control">
                        <input v-model.trim="localUnitDetails.decomission_real_sale_value" type="text" placeholder="Ej. 18000 transferencia, 18000 efectivo" :disabled="!localUnitDetails.is_decomissioned" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'files'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Documentos / Imágenes</h4>
                  <button type="button" class="btn ghost media-download-all" @click="downloadAllUnitFiles">
                    DESCARGAR TODO
                  </button>
                </div>
                <div class="container-card-body">
                  <div class="media-section">
                    <div class="media-header">
                      <h5>Imágenes</h5>
                    </div>
                    <div class="media-grid">
                      <button
                        type="button"
                        class="media-card media-add"
                        @click="uploadUnitFile('image')"
                        :disabled="uploadingMedia"
                      >
                        <span class="media-plus">+</span>
                        <span class="media-add-label">Agregar imagen</span>
                      </button>

                      <div class="media-card" v-for="item in imageFiles" :key="item.file_id">
                        <img :src="item.preview_url" :alt="item.title || item.file_name" class="media-preview" />
                        <div class="media-meta">
                          <h6>{{ item.title || "Sin título" }}</h6>
                          <p>{{ item.description || "Sin descripción" }}</p>
                        </div>
                        <div class="media-actions">
                          <button type="button" class="btn ghost media-btn" @click="openFile(item)">Ver</button>
                          <button type="button" class="btn ghost media-btn" @click="downloadFile(item)">Descargar</button>
                          <button type="button" class="btn remove-item-btn media-btn" @click="deleteUnitFile(item.file_id)">Eliminar</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="media-section">
                    <div class="media-header">
                      <h5>Documentos</h5>
                    </div>
                    <div class="media-grid">
                      <button
                        type="button"
                        class="media-card media-add"
                        @click="uploadUnitFile('document')"
                        :disabled="uploadingMedia"
                      >
                        <span class="media-plus">+</span>
                        <span class="media-add-label">Agregar documento</span>
                      </button>

                      <div class="media-card" v-for="item in documentFiles" :key="item.file_id">
                        <div class="media-doc-icon">DOC</div>
                        <div class="media-meta">
                          <h6>{{ item.title || item.file_name || "Documento" }}</h6>
                          <p>{{ item.description || "Sin descripción" }}</p>
                        </div>
                        <div class="media-actions">
                          <button type="button" class="btn ghost media-btn" @click="openFile(item)">Abrir</button>
                          <button type="button" class="btn ghost media-btn" @click="downloadFile(item)">Descargar</button>
                          <button type="button" class="btn remove-item-btn media-btn" @click="deleteUnitFile(item.file_id)">Eliminar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else class="container-card">
          <div class="section-title">
            <h4>Sección</h4>
          </div>
          <div class="container-card-body">
            <p>Selecciona una pestaña.</p>
          </div>
        </section>
      </div>
    </div>

    <footer class="savebar">
      <div class="savebar-left">
        <span class="dot" :class="{ dirty: isDirty }"></span>
        <span class="savebar-text">
          <b v-if="isDirty">Cambios sin guardar</b>
          <span v-else>Todo guardado</span>
        </span>
      </div>
      <div class="savebar-actions">
        <button class="btn ghost" @click="resetLocal" :disabled="saving_unit || !isDirty">Descartar</button>
        <button
          v-if="canUpdate"
          class="btn primary"
          @click="saveUnitProfile"
          :disabled="saving_unit || !isDirty"
        >
          <span v-if="!saving_unit">Guardar</span>
          <span v-else>Guardando…</span>
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "UnitEditor",
  props: ["unitDetails"],
  data() {
    return {
      activeTab: "general",
      saving_unit: false,
      permissions: [],
      localUnitDetails: { ...this.unitDetails },
      pristineSnapshot: JSON.stringify({ ...this.unitDetails }),
      verificationsList: [],
      leasesList: [],
      certificationsList: [],
      imageFiles: [],
      documentFiles: [],
      certificationFiles: {},
      uploadingMedia: false,
      tabs: [
        { key: "general", label: "DATOS GENERALES", hint: "UNIDAD / ADMINISTRATIVO / ESTADO" },
        { key: "truck", label: "CAMIÓN / EQUIPO", hint: "CAMIÓN / EQUIPO" },
        { key: "informative", label: "INFORMATIVO", hint: "SCT / PÓLIZAS / VERIFICACIONES / ARRENDAMIENTOS" },
        { key: "bajas", label: "BAJAS", hint: "INFORMACIÓN DE BAJA" },
        { key: "files", label: "DOCUMENTOS / IMÁGENES", hint: "GALERÍA DE ARCHIVOS" },
      ],
      unit_id: this.unitDetails?.unit_id,
      unit_short_id: this.unitDetails?.unit_short_id,
      unit_owner: this.unitDetails?.unit_owner,
      unit_plates: this.unitDetails?.unit_plates,
      unit_engine_num: this.unitDetails?.unit_engine_num,
      unit_brand: this.unitDetails?.unit_brand,
      unit_sub_brand: this.unitDetails?.unit_sub_brand,
      unit_model: this.unitDetails?.unit_model,
      unit_class: this.unitDetails?.unit_class,
      unit_type: this.unitDetails?.unit_type,
      unit_category: this.unitDetails?.unit_category,
      unit_status: this.unitDetails?.unit_status,
      unit_deleted: this.unitDetails?.unit_deleted,
      gps_id: this.unitDetails?.gps_id,
      comments: this.unitDetails?.comments,
    };
  },
  computed: {
    isDirty() {
      return JSON.stringify(this.buildPayload()) !== this.pristineSnapshot;
    },
    canUpdate() {
      return this.permissions.includes("maintenance.update_unit") ||
        this.permissions.includes("access_control.maintenance.update_unit") ||
        this.permissions.includes("ui_access_units_edit") ||
        this.permissions.includes("access_control.ui_access_units_edit");
    },
    visibleTabs() {
      if (!this.localUnitDetails.enable_certifications) return this.tabs;
      const tabs = [...this.tabs];
      const informativeIndex = tabs.findIndex((tab) => tab.key === "informative");
      tabs.splice(informativeIndex + 1, 0, {
        key: "certifications",
        label: "CERTIFICACIONES",
        hint: "NOMBRE / VIGENCIA / DOCUMENTOS",
      });
      return tabs;
    },
    savedCertificationIds() {
      try {
        const parsed = JSON.parse(this.pristineSnapshot || "{}");
        const list = Array.isArray(parsed.certifications) ? parsed.certifications : [];
        return new Set(list.map((item) => item && item.id).filter(Boolean));
      } catch (error) {
        return new Set();
      }
    },
  },
  watch: {
    unitDetails: {
      deep: true,
      handler(newVal) {
        this.hydrateLocalUnitDetails(newVal);
        this.pristineSnapshot = JSON.stringify(this.buildPayload());
        this.fetchUnitFiles();
        if (!this.localUnitDetails.enable_certifications && this.activeTab === "certifications") {
          this.activeTab = "informative";
        }
      },
    },
  },
  async created() {
    this.hydrateLocalUnitDetails(this.unitDetails);
    this.pristineSnapshot = JSON.stringify(this.buildPayload());
    this.loadPermissions();
    await this.fetchUnitFiles();
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem("userPermissions")) || [];
      } catch (error) {
        this.permissions = [];
      }
    },
    defaultVerification() {
      return { type: "", folio: "", verification_date: "", period: "", expiration: "" };
    },
    defaultLease() {
      return {
        lessor: "",
        contract_number: "",
        start_date: "",
        end_date: "",
        monthly_amount: "",
        purchase_option_amount: "",
      };
    },
    newCertificationId() {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }
      return `cert-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    },
    defaultCertification() {
      return {
        id: this.newCertificationId(),
        name: "",
        obtained_date: "",
        expiration: "",
        comments: "",
      };
    },
    normalizeCertifications(value) {
      if (Array.isArray(value) && value.length) {
        return value.map((item) => ({
          id: (item && item.id) || this.newCertificationId(),
          name: (item && item.name) || "",
          obtained_date: (item && item.obtained_date) || "",
          expiration: (item && item.expiration) || "",
          comments: (item && item.comments) || "",
        }));
      }
      return [this.defaultCertification()];
    },
    sanitizeCertifications(list) {
      const cleaned = (list || [])
        .map((item) => ({
          id: item.id,
          name: (item.name ?? "").toString().trim(),
          obtained_date: (item.obtained_date ?? "").toString().trim(),
          expiration: (item.expiration ?? "").toString().trim(),
          comments: (item.comments ?? "").toString().trim(),
        }))
        .filter((item) => item.id && (item.name || item.obtained_date || item.expiration || item.comments));
      return cleaned.length ? cleaned : null;
    },
    certificationStatus(cert) {
      if (!cert || !cert.expiration) return "";
      const now = new Date();
      const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
      return cert.expiration < today ? "Vencida" : "Vigente";
    },
    onEnableCertificationsChange() {
      if (this.localUnitDetails.enable_certifications) {
        if (!this.certificationsList.length) this.certificationsList.push(this.defaultCertification());
        this.activeTab = "certifications";
        return;
      }
      if (this.activeTab === "certifications") this.activeTab = "informative";
    },
    normalizeList(value, keys, factory) {
      if (Array.isArray(value) && value.length) {
        return value.map((item) => {
          const normalized = {};
          keys.forEach((key) => {
            normalized[key] = (item && item[key]) || "";
          });
          return normalized;
        });
      }
      return [factory()];
    },
    sanitizeList(list, keys) {
      const cleaned = list
        .map((item) => {
          const normalized = {};
          keys.forEach((key) => {
            normalized[key] = (item[key] ?? "").toString().trim();
          });
          return normalized;
        })
        .filter((item) => keys.some((key) => item[key]));
      return cleaned.length ? cleaned : null;
    },
    normalizeDateInput(value) {
      if (!value) return "";
      const match = String(value).trim().match(/^(\d{4}-\d{2}-\d{2})/);
      return match ? match[1] : "";
    },
    serializeDateForApi(value) {
      const normalized = this.normalizeDateInput(value);
      return normalized ? `${normalized}T00:00:00` : null;
    },
    buildPayload() {
      return {
        ...this.localUnitDetails,
        buy_time: this.serializeDateForApi(this.localUnitDetails.buy_time),
        value_update_time: this.serializeDateForApi(this.localUnitDetails.value_update_time),
        equipment_buy_time: this.serializeDateForApi(this.localUnitDetails.equipment_buy_time),
        verifications: this.sanitizeList(this.verificationsList, ["type", "folio", "verification_date", "period", "expiration"]),
        leases: this.sanitizeList(this.leasesList, ["lessor", "contract_number", "start_date", "end_date", "monthly_amount", "purchase_option_amount"]),
        enable_certifications: !!this.localUnitDetails.enable_certifications,
        certifications: this.sanitizeCertifications(this.certificationsList),
      };
    },
    hydrateLocalUnitDetails(data) {
      const source = { ...(data || {}) };
      source.buy_time = this.normalizeDateInput(source.buy_time);
      source.value_update_time = this.normalizeDateInput(source.value_update_time);
      source.equipment_buy_time = this.normalizeDateInput(source.equipment_buy_time);
      this.verificationsList = this.normalizeList(
        source.verifications,
        ["type", "folio", "verification_date", "period", "expiration"],
        this.defaultVerification,
      );
      this.leasesList = this.normalizeList(
        source.leases,
        ["lessor", "contract_number", "start_date", "end_date", "monthly_amount", "purchase_option_amount"],
        this.defaultLease,
      );
      source.enable_certifications = !!source.enable_certifications;
      this.certificationsList = this.normalizeCertifications(source.certifications);
      source.verifications = this.sanitizeList(this.verificationsList, ["type", "folio", "verification_date", "period", "expiration"]);
      source.leases = this.sanitizeList(this.leasesList, ["lessor", "contract_number", "start_date", "end_date", "monthly_amount", "purchase_option_amount"]);
      source.certifications = this.sanitizeCertifications(this.certificationsList);
      this.localUnitDetails = source;
    },
    addVerification() {
      this.verificationsList.push(this.defaultVerification());
    },
    removeVerification(index) {
      this.verificationsList.splice(index, 1);
      if (!this.verificationsList.length) this.verificationsList.push(this.defaultVerification());
    },
    addLease() {
      this.leasesList.push(this.defaultLease());
    },
    removeLease(index) {
      this.leasesList.splice(index, 1);
      if (!this.leasesList.length) this.leasesList.push(this.defaultLease());
    },
    addCertification() {
      this.certificationsList.push(this.defaultCertification());
    },
    async removeCertification(index) {
      const cert = this.certificationsList[index];
      if (this.filesForCertification(cert && cert.id).length) {
        const result = await Swal.fire({
          title: "Quitar certificación",
          text: "Sus documentos se eliminarán cuando guardes la unidad.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Quitar",
          cancelButtonText: "Cancelar",
        });
        if (!result.isConfirmed) return;
      }
      this.certificationsList.splice(index, 1);
      if (!this.certificationsList.length) this.certificationsList.push(this.defaultCertification());
    },
    filesForCertification(id) {
      if (!id || !this.certificationFiles) return [];
      return this.certificationFiles[id] || [];
    },
    async fetchUnitFiles() {
      try {
        const objectId = this.unitDetails?.unit_id;
        if (!objectId) return;
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/get-files/`, {
          params: { object_type: "unit", object_id: objectId },
        });
        const files = Array.isArray(response.data) ? response.data : [];
        const imageFiles = [];
        const documentFiles = [];
        const certificationFiles = {};
        files.forEach((file) => {
          const metadata = file.metadata || {};
          const mimeType = metadata.file_type || "";
          const category = metadata.category || (mimeType.startsWith("image/") ? "image" : "document");
          const item = {
            file_id: file.file_id,
            title: metadata.title || "",
            description: metadata.description || "",
            file_name: metadata.file_name || "",
            mime_type: mimeType,
            preview_url: `data:${mimeType || "application/octet-stream"};base64,${file.content}`,
          };
          if (category === "certification" && metadata.certification_id) {
            if (!certificationFiles[metadata.certification_id]) certificationFiles[metadata.certification_id] = [];
            certificationFiles[metadata.certification_id].push(item);
            return;
          }
          if (category === "image") imageFiles.push(item);
          else documentFiles.push(item);
        });
        this.imageFiles = imageFiles;
        this.documentFiles = documentFiles;
        this.certificationFiles = certificationFiles;
      } catch (error) {
        if (error?.response?.status !== 404) console.error("Error fetching unit files:", error);
        this.imageFiles = [];
        this.documentFiles = [];
        this.certificationFiles = {};
      }
    },
    async uploadUnitFile(category, certificationId = null) {
      try {
        const file = await new Promise((resolve) => {
          const input = document.createElement("input");
          input.type = "file";
          input.accept = category === "image" ? "image/*" : "*/*";
          input.onchange = (event) => resolve(event.target.files?.[0] || null);
          input.click();
        });
        if (!file) return;

        const metadataPrompt = await Swal.fire({
          title: "Detalles del archivo",
          html: `
            <input id="unit-file-title" class="swal2-input" placeholder="Título" value="${file.name.replace(/"/g, "&quot;")}">
            <textarea id="unit-file-description" class="swal2-textarea" placeholder="Descripción"></textarea>
          `,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: "Subir",
          cancelButtonText: "Cancelar",
          preConfirm: () => {
            const title = document.getElementById("unit-file-title")?.value?.trim() || "";
            const description = document.getElementById("unit-file-description")?.value?.trim() || "";
            if (!title) {
              Swal.showValidationMessage("El título es obligatorio");
              return null;
            }
            return { title, description };
          },
        });
        if (!metadataPrompt.isConfirmed || !metadataPrompt.value) return;

        const objectId = this.unitDetails?.unit_id;
        if (!objectId) {
          Swal.fire("Error", "No se encontró el identificador de la unidad.", "error");
          return;
        }

        const metadata = {
          category,
          title: metadataPrompt.value.title,
          description: metadataPrompt.value.description,
          file_name: file.name,
          file_type: file.type,
        };
        if (certificationId) metadata.certification_id = certificationId;

        const formData = new FormData();
        formData.append("file", file);
        formData.append("object_type", "unit");
        formData.append("object_id", objectId);
        formData.append("object_metadata", JSON.stringify(metadata));

        const apiDirectory = process.env.API_DIRECTORY;
        this.uploadingMedia = true;
        await axios.post(`${apiDirectory}/upload-file`, formData);
        await this.fetchUnitFiles();
        Swal.fire("Completado", "Archivo subido correctamente.", "success");
      } catch (error) {
        console.error("Error uploading unit file:", error);
        Swal.fire("Error", "No se pudo subir el archivo.", "error");
      } finally {
        this.uploadingMedia = false;
      }
    },
    openFile(item) {
      if (!item?.preview_url) return;
      window.open(item.preview_url, "_blank");
    },
    downloadFile(item) {
      if (!item?.preview_url) return;
      const link = document.createElement("a");
      link.href = item.preview_url;
      link.download = item.file_name || item.title || `archivo-${item.file_id}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async downloadAllUnitFiles() {
      const certificationDocs = Object.values(this.certificationFiles || {}).flat();
      const allFiles = [...this.imageFiles, ...this.documentFiles, ...certificationDocs];
      if (!allFiles.length) {
        Swal.fire("Sin archivos", "No hay archivos para descargar.", "info");
        return;
      }
      allFiles.forEach((item, index) => {
        setTimeout(() => this.downloadFile(item), index * 160);
      });
      Swal.fire("Completado", "Se iniciaron las descargas de todos los archivos.", "success");
    },
    async pruneCertificationFiles(savedCertifications) {
      const savedIds = new Set((savedCertifications || []).map((item) => item && item.id).filter(Boolean));
      const fileIds = [];
      Object.entries(this.certificationFiles || {}).forEach(([certId, files]) => {
        if (savedIds.has(certId)) return;
        (files || []).forEach((file) => {
          if (file.file_id) fileIds.push(file.file_id);
        });
      });
      if (!fileIds.length) return;
      const apiDirectory = process.env.API_DIRECTORY;
      await Promise.all(fileIds.map(async (blobId) => {
        try {
          await axios.post(`${apiDirectory}/delete-file/`, { blob_id: blobId });
        } catch (error) {
          console.error("Error deleting certification file:", error);
        }
      }));
      await this.fetchUnitFiles();
    },
    async deleteUnitFile(fileId) {
      try {
        const result = await Swal.fire({
          title: "Eliminar archivo",
          text: "¿Deseas eliminar este archivo?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
        });
        if (!result.isConfirmed) return;
        const apiDirectory = process.env.API_DIRECTORY;
        await axios.post(`${apiDirectory}/delete-file/`, { blob_id: fileId });
        await this.fetchUnitFiles();
        Swal.fire("Completado", "Archivo eliminado.", "success");
      } catch (error) {
        console.error("Error deleting unit file:", error);
        Swal.fire("Error", "No se pudo eliminar el archivo.", "error");
      }
    },
    backMainPanel() {
      window.location.href = "/main-panel";
    },
    resetLocal() {
      this.hydrateLocalUnitDetails(JSON.parse(this.pristineSnapshot || "{}"));
    },
    async saveUnitProfile() {
      try {
        if (!this.canUpdate) {
          Swal.fire("Sin acceso", "No tienes permisos para actualizar unidades.", "warning");
          return;
        }
        const unit_id = this.unitDetails.unit_id;
        const apiDirectory = process.env.API_DIRECTORY;
        const payload = this.buildPayload();

        this.saving_unit = true;
        await axios.put(`${apiDirectory}/unit_detail/${unit_id}/`, payload);
        try {
          await this.pruneCertificationFiles(payload.certifications);
        } catch (pruneError) {
          console.error("Error pruning certification files:", pruneError);
        }

        this.localUnitDetails = {
          ...payload,
          buy_time: this.normalizeDateInput(payload.buy_time),
          value_update_time: this.normalizeDateInput(payload.value_update_time),
          equipment_buy_time: this.normalizeDateInput(payload.equipment_buy_time),
        };
        this.pristineSnapshot = JSON.stringify(this.buildPayload());
        Swal.fire("¡Actualizado!", "Los datos del formulario se han actualizado con éxito.", "success");
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Hubo un problema al actualizar los datos de la unidad.", "error");
      } finally {
        this.saving_unit = false;
      }
    },
  },
};
</script>
  
  <style scoped>
  .unit-editor {
    min-height: 100vh;
    background: #e9edf5;
    color: #0f172a;
  }
  
  /* Topbar */
  .topbar {
    position: sticky;
    top: 0;
    z-index: 20;
    min-height: 64px;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 8px 14px;
    background: #ffc434;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.16);
  }
  
  .logo-button {
    height: 46px;
    cursor: pointer;
  }
  
  .topbar-title {
    display: flex;
    flex-direction: column;
    line-height: 1.1;
  }
  
  .kicker {
    font-size: 12px;
    opacity: 0.75;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
  }
  
  .topbar-title h1 {
    margin: 0;
    font-size: 18px;
    font-weight: 900;
  }
  
  .subtitle {
    margin: 2px 0 0;
    font-size: 12px;
    opacity: 0.8;
  }
  
  .topbar-actions {
    margin-left: auto;
    display: flex;
    gap: 10px;
  }
  
  /* Tabs area */
  .tabs-wrap {
    max-width: 1280px;
    margin: 10px auto 76px;
    padding: 0 16px;
  }
  
  .tabs {
    display: flex;
    gap: 8px;
    overflow: auto;
    padding-bottom: 4px;
    scrollbar-width: thin;
  }
  
  .tab {
    border: 1px solid #94a3b8;
    background: #f8fafc;
    border-radius: 10px;
    padding: 8px 10px;
    min-width: 138px;
    text-align: left;
    cursor: pointer;
    transition: transform 120ms ease, box-shadow 120ms ease;
  }
  
  .tab:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 18px rgba(15, 23, 42, 0.08);
  }
  
  .tab.active {
    border-color: #1d4ed8;
    background: #dbeafe;
    box-shadow: 0 6px 14px rgba(29, 78, 216, 0.22);
  }
  
  .tab-label {
    display: block;
    font-weight: 900;
    font-size: 12px;
  }
  
  .tab-hint {
    display: block;
    font-size: 10px;
    opacity: 0.82;
    margin-top: 2px;
  }
  
  /* Tab content layout (similar to incident form) */
  .tab-panel {
    margin-top: 10px;
  }
  
  .main-data-container {
    display: grid;
    grid-template-columns: repeat(14, minmax(0, 1fr));
    gap: 10px;
  }

  .main-data-container.single-column {
    grid-template-columns: 1fr;
  }

  .maintenance-main {
    grid-column: span 10;
    display: grid;
    gap: 10px;
  }

  .maintenance-side {
    grid-column: span 4;
    display: grid;
    gap: 10px;
  }

  .main-data-container.single-column .maintenance-main,
  .main-data-container.single-column .maintenance-side {
    grid-column: 1 / -1;
  }

  .container-card {
    background: #f8fafc;
    border: 1px solid #cbd5e1;
    border-radius: 0;
    border-top: none;
    box-shadow: 0 4px 10px rgba(15, 23, 42, 0.08);
  }
  
  .section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 8px;
    border-bottom: 1px solid #cbd5e1;
    background: #dbe3ef;
  }

  .maintenance-title-row {
    gap: 10px;
  }
  
  .section-title h4 {
    margin: 0;
    font-size: 13px;
    font-weight: 800;
  }

  .container-card-body {
    padding: 8px;
  }
  
  .container-card-body p {
    margin: 2px 0 0;
    font-size: 12px;
    opacity: 0.75;
  }

  @media (max-width: 1120px) {
    .main-data-container {
      grid-template-columns: 1fr;
    }

    .maintenance-main,
    .maintenance-side {
      grid-column: 1 / -1;
    }
  }
  
  /* Pills */
  .pill {
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 0 8px;
    border-radius: 999px;
    background: #c7d2fe;
    color: #1e3a8a;
    font-weight: 900;
    font-size: 11px;
  }
  
  .pill.danger {
    background: #fecaca;
    color: #991b1b;
  }

  .pill.ok {
    background: #bbf7d0;
    color: #166534;
  }

  .field-hint {
    margin: 8px 0 0;
    font-size: 12px;
    color: #475569;
  }

  .cert-block {
    padding: 12px 0;
    border-bottom: 1px solid #dbe3ef;
  }

  .cert-block:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  .cert-block-head {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
  }

  .cert-block-head h5 {
    margin: 0;
    flex: 1;
    font-size: 13px;
    font-weight: 900;
  }

  .cert-files {
    margin-top: 12px;
  }
  
  /* Form grid */
  .form-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .form-grid-single {
    grid-template-columns: 1fr;
  }

  @media (max-width: 1400px) {
    .form-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .form-grid-single {
      grid-template-columns: 1fr;
    }
  }
  
  @media (max-width: 900px) {
    .form-grid {
      grid-template-columns: 1fr;
    }

    .form-grid-single {
      grid-template-columns: 1fr;
    }
  }
  
  /* Field wrapper (replacement for <Field>) */
  .field {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .field-label {
    font-size: 11px;
    font-weight: 900;
    opacity: 0.95;
    color: #0f172a;
  }
  
  .field-control input,
  .field-control select,
  .field-control textarea {
    width: 100%;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #94a3b8;
    background: #fff;
    outline: none;
    transition: box-shadow 120ms ease, border-color 120ms ease;
    font-size: 12px;
  }
  
  .field-control input:focus,
  .field-control select:focus,
  .field-control textarea:focus {
    border-color: #1d4ed8;
    box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.18);
  }
  
  .field-control textarea {
    min-height: 76px;
    resize: vertical;
  }

  .list-row {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr)) auto;
    gap: 10px;
    align-items: end;
    padding: 8px 0;
    border-bottom: 1px solid #dbe3ef;
  }

  .list-row:last-child {
    border-bottom: none;
  }

  .mini-action-btn {
    padding: 4px 10px;
    font-size: 11px;
  }

  .remove-item-btn {
    padding: 6px 10px;
    font-size: 11px;
    background: #ef4444;
    color: #fff;
    border-color: #dc2626;
  }

  @media (max-width: 1400px) {
    .list-row {
      grid-template-columns: repeat(3, minmax(0, 1fr)) auto;
    }
  }

  @media (max-width: 900px) {
    .list-row {
      grid-template-columns: 1fr;
      align-items: stretch;
    }
  }
  
  .span-2 {
    grid-column: span 3;
  }

  @media (max-width: 1400px) {
    .span-2 {
      grid-column: span 2;
    }
  }
  
  @media (max-width: 900px) {
    .span-2 {
      grid-column: span 1;
    }
  }
  
  /* Toggle */
  .toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 8px;
    border-radius: 8px;
    border: 1px dashed #64748b;
    background: #eef2ff;
  }
  
  .toggle input {
    width: 18px;
    height: 18px;
  }
  
  /* Buttons */
  .btn {
    border: 1px solid #64748b;
    border-radius: 8px;
    padding: 8px 10px;
    font-weight: 900;
    font-size: 12px;
    cursor: pointer;
    transition: transform 120ms ease, box-shadow 120ms ease;
  }
  
  .btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  
  .btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 10px 18px rgba(15, 23, 42, 0.10);
  }
  
  .btn.primary {
    background: #1d4ed8;
    color: #fff;
    border-color: #1e40af;
  }
  
  .btn.ghost {
    background: #e2e8f0;
  }
  
  /* Savebar */
  .savebar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 25;
    background: rgba(226, 232, 240, 0.96);
    backdrop-filter: blur(10px);
    border-top: 1px solid #94a3b8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 14px;
  }
  
  .savebar-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .dot {
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: rgba(15, 23, 42, 0.25);
  }
  
  .dot.dirty {
    background: #ffc434;
    box-shadow: 0 0 0 6px rgba(255, 196, 52, 0.22);
  }
  
  .savebar-text {
    font-size: 12px;
    opacity: 0.9;
  }
  
  .savebar-actions {
    display: flex;
    gap: 10px;
  }

  .media-section {
    margin-bottom: 16px;
  }

  .media-header h5 {
    margin: 0 0 10px;
    font-size: 13px;
    font-weight: 900;
  }

  .media-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 10px;
  }

  .media-card {
    border: 1px solid #94a3b8;
    border-radius: 10px;
    background: #fff;
    min-height: 180px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .media-add {
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #eff6ff;
    border-style: dashed;
    padding: 10px;
  }

  .media-plus {
    font-size: 42px;
    line-height: 1;
    font-weight: 900;
    color: #1d4ed8;
  }

  .media-add-label {
    margin-top: 8px;
    font-size: 12px;
    font-weight: 800;
    color: #1e3a8a;
  }

  .media-preview {
    width: 100%;
    height: 120px;
    object-fit: cover;
    background: #e2e8f0;
  }

  .media-doc-icon {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #dbeafe;
    color: #1e3a8a;
    font-size: 22px;
    font-weight: 900;
  }

  .media-meta {
    padding: 8px;
    display: grid;
    gap: 4px;
    flex: 1;
  }

  .media-meta h6 {
    margin: 0;
    font-size: 12px;
    font-weight: 900;
  }

  .media-meta p {
    margin: 0;
    font-size: 11px;
    color: #334155;
  }

  .media-actions {
    padding: 0 8px 8px;
    display: flex;
    gap: 6px;
  }

  .media-btn {
    flex: 1;
    padding: 6px 8px;
    font-size: 11px;
  }

  .media-download-all {
    padding: 6px 10px;
    font-size: 11px;
  }
  </style>  